import { BlogPageResolver } from "./BlogPageResolver";
import { BasePageProviders } from "./PageProviders";

export const BlogPageProviders = () => (
  <BasePageProviders>
    <BlogPageResolver />
  </BasePageProviders>
);
